import type { TMessages } from '@/types/TMessages'

export const messages = {
  title: 'Льготный лизинг',
  blockNote: 'Специальная программа Минпромторга',
  text: 'Грузовой транспорт, ЛКТ, автобусы<br/> и легковые автомобили',
  note: 'Для малого и среднего предпринимательства, признанных ФЗ №209 от 24.07.2007',
  options: {
    uptoTenPercents: { text: 'до 10%', caption: 'скидка от стоимости' },
    uptoFiveHundred: {
      text: 'до 500 тыс. <span class="uom">₽</span>',
      caption: 'скидка на одно т/с',
    },
    chooseCircle: 'или',
  },
} satisfies TMessages
